<script lang="ts">
    import SvgIcon from "../SVGIcon.svelte";
    import { ClusterStore } from "$/stores/ClusterStore";
    import { TenantStore } from "$/stores/TenantStore";
    import { TokenStore } from "$/stores/TokenStore";
    import {
        ActiveTopicStore,
        ActiveTopic,
        TopicAccessLevel,
    } from "$/stores/extension/ActiveTopicStore";
    import { getRole } from "$/utils/Utils";
    import { tooltip } from "$/utils/tooltip";

    export let snippet;

    $: numberOfLikes =
        snippet?.reactions?.filter((reaction) => reaction.type === 1).length ||
        0;
    $: tooltipContent = generateTooltipContent(snippet) || "";
    $: currentUserReaction = checkIfUserReacted(snippet);
    $: userRole = $ActiveTopic
        ? getRole(
              $ActiveTopic,
              $TokenStore.user?.id,
              $TenantStore?.tenants,
              $ClusterStore.clusters,
          )
        : TopicAccessLevel.NO_ACCESS;

    const mockReaction = {
        id: "00000000-0000-0000-0000-000000000000",
        type: 1,
        createdBy: $TokenStore?.user,
    };

    let loading = false;

    async function handleLikePress() {
        if (!snippet.id || loading) return;

        loading = true;

        if (!currentUserReaction) {
            await ActiveTopicStore.updateSnippetReaction(
                snippet.id,
                $ActiveTopic.id,
                mockReaction,
            );
        } else {
            await ActiveTopicStore.deleteSnippetReaction(
                snippet.id,
                $ActiveTopic.id,
                currentUserReaction.id,
            );
        }

        loading = false;
    }

    function generateTooltipContent(newSnippet) {
        return newSnippet.reactions
            ?.reduce((acc, reaction) => {
                if (reaction.type === 1) {
                    acc.push(
                        `${reaction.createdBy.firstName} ${reaction.createdBy.lastName}`,
                    );
                }
                return acc;
            }, [])
            .join("<br>");
    }

    function checkIfUserReacted(newSnippet) {
        return newSnippet.reactions?.find(
            (reaction) =>
                reaction.createdBy.id === $TokenStore?.user?.id &&
                reaction.type === 1,
        );
    }
</script>

<div class="like-wrapper">
    {#if userRole > TopicAccessLevel.VIEWER && !snippet.archived}
        <button
            use:tooltip={!snippet.id && "Loading, please wait"}
            class="icon-button"
            on:click={handleLikePress}
        >
            {#if currentUserReaction}
                <SvgIcon
                    name="hand-thumb-up-solid"
                    size={16}
                    strokeWidth="1.5"
                />
            {:else}
                <SvgIcon name="hand-thumb-up" size={16} strokeWidth="1.5" />
            {/if}
        </button>
    {/if}
    {#if numberOfLikes > 0}
        <span class="text" use:tooltip={tooltipContent}>
            {numberOfLikes}
            {numberOfLikes === 1 ? "Like" : "Likes"}
        </span>
    {/if}
</div>

<style>
    .like-wrapper {
        @apply reset flex items-center !important;
    }

    .icon-button {
        @apply reset flex cursor-pointer rounded px-1 text-gray-500 text-inherit hover:bg-gray-200 hover:text-gray-600 !important;
    }

    .text {
        @apply reset ml-1 text-xs text-gray-500 text-inherit transition-colors hover:text-black !important;
    }
</style>
